import { Button } from '@retailer-platform/shared-components'
import { type ButtonControl } from '../rete/controls.tsx'

interface PipelineEditorCustomButtonProps {
  data: ButtonControl
}

/**
 * Example
 */
export function PipelineEditorCustomButton({ data }: PipelineEditorCustomButtonProps) {
  return (
    <Button
      onPointerDown={e => e.stopPropagation()}
      onDoubleClick={e => e.stopPropagation()}
      onClick={data.onClick}
    >
      {data.label}
    </Button>
  )
}
